module.exports = __webpack_public_path__ + "img/signature_2.8f5276a7.png";